<template>
  <div class="personal_warp">
    <myHeader />
    <div class="personal_content">
      <div class="personal_title">
        <h3>User center</h3>
        <div>
          <button @click="goOrder" class="btn1">My Order</button>
          <button @click="logOut">Quit</button>
        </div>
      </div>
      <div class="personal_info">
        <div class="info_item">
          <div class="item">
            <label>Account</label>
            <input :value="userInfo.hecoos_account || 'No information yet'" type="text" disabled>
          </div>
          <div class="item">
            <label>ID</label>
            <input :value="userInfo.rname || 'No information yet'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>Name</label>
            <input :value="userInfo.name || 'No information yet'" type="text" disabled>
          </div>
          <div class="item">
            <label>E-mail</label>
            <input :value="userInfo.email || 'No information yet'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>Phone</label>
            <input :value="userInfo.phone || 'No information yet'" type="text" disabled>
          </div>
          <div class="item">
            <label>City</label>
            <input :value="userInfo.city || 'No information yet'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>Company</label>
            <input :value="userInfo.company || 'No information yet'" type="text" disabled>
          </div>
          <div class="item">
            <label>Seniority</label>
            <input :value="userInfo.work_duration || 'No information yet'" type="text" disabled>
          </div>
        </div>
        <div class="info_item">
          <div class="item">
            <label>Job</label>
            <input :value="userInfo.position || 'No information yet'" type="text" disabled>
          </div>
          <div class="item" v-if="userInfo.phone || userInfo.email">
            <label>Password</label>
            <button @click="jumpTo('/en/forget_password')">Reset password</button>
          </div>
        </div>
      </div>
      <!-- <div class="vip_time">
        <p>Member Time：{{ userInfo.member_time }}</p>
        <button @click="jumpTo('/en/SoftwareSubscriptions')">
          Renewal
        </button>
      </div> -->
      <div class="vip_time">
        <p class="vip">Member Time：</p>
        <p class="time" v-if="start_time">{{ start_time }} ~ <br />{{ stop_time }}</p>
        <p class="time" v-else>None</p>
        <button @click="jumpTo('/en/SoftwareSubscriptions')">
          Renew
        </button>
      </div>
      <button v-if="!userInfo.is_trial && (userInfo.phone || userInfo.email)" class="get_vip" @click="showModal = true">Get one month free license</button>
      <div v-else class="footer_text">
        <p style="margin-bottom: 10px;">Invitation link: <span v-text="inviteLink + userInfo.recode"></span><button @click="copyInviteLink">Copy the
            link</button></p>
        <p style="font-size: 14px; text-align: left;">Please share this link.
          After successfully inviting one friend to register as a member of hcoos, your member account will
          automatically receive 7 days of free duration. Inviting multiple friends to register can accumulate the free
          duration, with a maximum of 60 days (worth 396 yuan).</p>
        <table v-if="userInfo.invite_register.length > 0">
          <thead>
            <tr>
              <th>Serial Number</th>
              <th>Inviter</th>
              <th>Registration time</th>
              <th>Reward duration</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(userInfoItem, index) in userInfo.invite_register" :key="userInfoItem.id">
              <td>{{ index + 1 }}</td>
              <td>{{ userInfoItem.name }}</td>
              <td>{{ userInfoItem.register_time }}</td>
              <td>{{ userInfoItem.time }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Modal Dialog -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-content">
        <div class="modal-header">
          <h3>Complete personal information</h3>
          <button class="close-btn" @click="showModal = false">&times;</button>
        </div>
        <div class="modal-body">
          <p data-label="Nickname:"><input type="text" v-model="userInfo.rname"></p>
          <p data-label="Name:"><input type="text" v-model="userInfo.name"></p>
          <p data-label="Email:"><input type="text" v-model="userInfo.email"></p>
          <p data-label="Company Name:"><input type="text" v-model="userInfo.company"></p>
          <p data-label="City:"><input type="text" v-model="userInfo.city"></p>
          <p data-label="Position:"><input type="text" v-model="userInfo.position"></p>
          <p data-label="Working experience:">
            <select v-model="userInfo.work_duration" name="" id="">
              <option value="1">1 year</option>
              <option value="2">2 years</option>
              <option value="3">3 years</option>
              <option value="4">4 years</option>
              <option value="5">5 years</option>
              <option value="6">6 years</option>
              <option value="7">7 years</option>
              <option value="8">8 years</option>
              <option value="9">9 years</option>
              <option value="10">10 years</option>
              <option value="11">More than 10 years</option>
            </select>
          </p>
        </div>
        <div class="modal-footer">
          <button class="confirm-btn" @click="confirmAuthorization">Confirm authorization</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import store from "@/store";
import { Message } from "element-ui"
import { getFreeVip,getPaySuccess } from "@/api/api";
export default {
  name: 'mobile_personalCenter',
  components: { myHeader, },
  data() {
    return {
      userInfo: {
        account: "",
        nickname: "",
        name: "",
        email: "",
        phone: "",
        city: "",
        company: "",
        workTime: "",
        position: "",
        memberExpire: "",
        recode: '',
        is_trial: ''
      },
      showModal: false,
      inviteLink: '',
      start_time:'',
      stop_time:'',
    }
  },
  created() {
    // 动态生成邀请链接
    this.inviteLink = `${window.location.origin}/#/register?recode=`
    if(store.state.adminUserInfo &&store.state.adminUserInfo.id){
      this.getPaySuccess()
    }
  },
  beforeMount() {
    this.userInfo = store.state.adminUserInfo;
    this.userInfo.is_trial = Number(this.userInfo.is_trial)
  },
  methods: {
    getPaySuccess(){
      getPaySuccess().then(res => {
        if(res.code == 200){
          if(res.data){
            let {start_time , stop_time} = res.data
            this.start_time = start_time
            this.stop_time = stop_time
          }

        }
      });
    },
    jumpTo(url) {
      this.$router.push(url)
    },
    goOrder() {
      this.$router.push("/en/order");
    },
    // 登出
    logOut() {
      store.commit("clearAdminUserInfo");
      localStorage.clear();
      this.$router.push("/en/login");
    },
    // 复制链接
    copyInviteLink() {
      navigator.clipboard.writeText(this.inviteLink + this.userInfo.recode)
        .then(() => {
          Message.success("Copy successful");
        })
        .catch(err => {
          Message.error("Copy operation failed...");
        });
    },
    // 获取免费会员
    confirmAuthorization() {
      // console.log(this.userInfo);
      let postData = {
        name: this.userInfo.name,
        rname: this.userInfo.rname,
        email: this.userInfo.email,
        company: this.userInfo.company,
        city: this.userInfo.city,
        position: this.userInfo.position,
        work_duration: this.userInfo.work_duration,
      }
      // console.log(postData);

      getFreeVip(postData).then(res => {
        Message.success('To obtain success, please log in again.');
        setTimeout(() => {
          this.logOut()
        }, 1000)
      });

      this.showModal = false;
    },
  }
}
</script>
<style lang="scss" scoped>
.personal_warp {
  .personal_content {
    padding: 30px;
    margin: 0 auto;
    max-width: 500px;

    .personal_title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h3 {
        font-size: 24px;
      }

      button {
        border: none;
        padding: 10px 24px;
        background-color: #000;
        color: #fff;
        font-size: 14px;
        border-radius: 8px;
        &.btn1{
          background-color: #1684ED;
          margin-right: 12px;
        }
      }
    }

    .personal_info {
      margin-top: 30px;

      .info_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        margin-bottom: 16px;

        .item {
          width: 100%;

          label {
            display: block;
            font-size: 14px;
            margin-bottom: 4px;
          }

          input {
            width: 100%;
            height: 34px;
            border: 1px solid #e4e6ef;
            border-radius: 4px;
            padding: 0 10px;
            background-color: #f9f9f9;
            font-size: 14px;
          }

          button {
            border: 1px solid #2a82e4;
            width: 100%;
            // padding: ;
            padding: 8px 16px;
            border-radius: 8px;
            background-color: #fff;
            color: #2a82e4;
          }
        }
      }
    }

    .vip_time {
      display: flex;
      justify-content: space-around;
      gap: 10px;
      margin: 24px 0 30px;

      p {
        font-size: 14px;
        // text-align:center;
        // padding: 8px 0;
      }

      .vip {
        width: 80px;
      }

      .time {
        width: 175px;
      }

      button {
        // width: 100%;
        width: 80px;
        height: 40px;
        border: none;
        background-color: #2a82e4;
        color: #fff;
        padding: 8px 12px;
        border-radius: 8px;
      }
    }

    .get_vip {
      width: 100%;
      display: block;
      margin: 0 auto;
      border: none;
      font-size: 14px;
      padding: 12px 24px;
      background-color: #000;
      color: #fff;
      border-radius: 20px;
      margin-top: 32px;
    }
  }

  .footer_text {
    text-align: center;
    font-size: 16px;

    span {
      color: #2a82e4;
    }

    button {
      border: none;
      font-size: 10px;
      padding: 6px 12px;
      border-radius: 13px;
      margin-left: 6px;
      background-color: #cccccc;
      color: #fff;
      cursor: pointer;
    }

    table {
      // width: 70%;
      border-collapse: collapse;
      margin-top: 20px;
      margin: 20px auto;
    }

    th,
    td {
      border: 1px solid #ddd;
      padding: 8px 12px;
      text-align: left;
    }

    th {
      background-color: #f2f2f2;
      font-weight: bold;
    }

    tr:nth-child(even) {
      background-color: #f9f9f9;
    }

    tr:hover {
      background-color: #f1f1f1;
    }

    .header {
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: bold;
    }
  }

  /* Modal Styles */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    border-radius: 10px;
    width: 600px;
    max-width: 90%;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .modal-header {
    padding: 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 24px;
      cursor: pointer;
      color: #777;
      padding: 0;
      line-height: 1;
    }
  }

  .modal-body {
    padding: 20px 54px;

    p {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 14px;

      &::before {
        content: attr(data-label);
        display: inline-block;
        width: 80px;
        text-align: justify;
        text-align-last: justify;
        padding-right: 10px;
      }

      input,
      select {
        // 同时为input和select设置相同样式
        flex: 1;
        height: 40px;
        border: 1px solid #e4e6ef;
        border-radius: 4px;
        padding: 0 10px;
        background-color: #f9f9f9;
        font-size: 14px;
        appearance: none; // 移除默认样式
        background-repeat: no-repeat;
        background-position: right 10px center;
        background-size: 12px;
      }

      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23777'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e");


        option {
          padding: 8px;
        }
      }
    }
  }

  .modal-footer {
    padding: 20px;
    border-top: 1px solid #eee;
    text-align: center;

    .confirm-btn {
      background-color: #2a82e4;
      color: white;
      border: none;
      border-radius: 20px;
      padding: 10px 30px;
      font-size: 16px;
      cursor: pointer;
      transition: background-color 0.3s;

      &:hover {
        background-color: #1a6bc8;
      }
    }
  }
}
</style>
